import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ManageUserForm } from "./ManageUserForm";

export const ManageUserModal = ({
  modalState,
  toggleModal,
  translate,
  defaultValues,
  handleSubmit,
}) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    surname: Yup.string().required("Required"),
  });

  return (
    <Modal isOpen={modalState} toggle={() => toggleModal(false)}>
      <ModalHeader>{translate("manageUser")}</ModalHeader>

      {defaultValues && (
        <Formik
          initialValues={defaultValues}
          onSubmit={(values) => handleSubmit(values)}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <ManageUserForm translate={translate} />
              </ModalBody>

              <ModalFooter>
                <Button type="submit">{translate("submitUser")}</Button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      )}
    </Modal>
  );
};
